import type { Point } from '../../hex/types';
import { hexPath } from './geometry';

/**
 * Clips drawing operations to the hex polygon for safe overlay rendering.
 */
export function clipHex(ctx: CanvasRenderingContext2D, verts: Point[], draw: () => void): void {
    ctx.save();
    hexPath(ctx, verts);
    ctx.clip();
    draw();
    ctx.restore();
}
